import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Container } from 'reactstrap';

import { supportUrl } from 'Config/lang';
import BundlesLink from 'Layout/NavBar/BundlesLink';
import CategoriesLink from 'Layout/NavBar/CategoriesLink';
import DiscoverLink from 'Layout/NavBar/DiscoverLink';
import StarDealButton from 'Components/Button/StarDealButton';
import store from 'Redux/store';
import useViewport from 'Hooks/useViewport';

const onLinkClick = (link, context = 'Generic') => {
  store.dispatch({
    type: 'frontend/click/CLICK_INTERACTION',
    payload: { section: 'SecondaryNavLinks', value: link, context },
  });
};

const SecondaryNavBar = ({
  setMegaMenuTab,
  megaMenuTab,
  siteBrand,
  onMegaMenuIntent,
}) => {
  const { isAboveMd } = useViewport();

  const showGiftGuide = false;
  const showBlog = false;
  const showMystery = !['de', 'br'].includes(window.locale);
  const showRedeemCode = siteBrand === 'hpomen';
  const showSupport = !['de', 'es', 'nl'].includes(window.locale) || isAboveMd;
  const showBlogLink = showBlog && window.locale === 'en' && siteBrand === 'fanatical';

  return (
    <div className="secondary-navbar">
      <Container>
        <div className="left-links-container" onMouseEnter={onMegaMenuIntent} onFocus={onMegaMenuIntent}>
          <Link to="/deals" className="secondary-nav-link" onClick={() => onLinkClick('/deals', 'Deals')}>
            <FormattedMessage id="nav-secondary.link.deals" defaultMessage="Deals" />
          </Link>

          <DiscoverLink
            setMegaMenuTab={setMegaMenuTab}
            megaMenuTab={megaMenuTab}
          />
          <CategoriesLink
            setMegaMenuTab={setMegaMenuTab}
            megaMenuTab={megaMenuTab}
          />
          <BundlesLink
            setMegaMenuTab={setMegaMenuTab}
            megaMenuTab={megaMenuTab}
          />

          <Link to="/upcoming-games" className="secondary-nav-link" onClick={() => onLinkClick('/upcoming-games', 'UpcomingGames')}>
            <FormattedMessage id="nav-secondary.link.comingsoon" defaultMessage="Upcoming Games" />
          </Link>

          <Link to="/new-releases" className="secondary-nav-link" onClick={() => onLinkClick('/new-releases', 'NewReleases')}>
            <FormattedMessage id="nav-secondary.link.newreleases" defaultMessage="New Releases" />
          </Link>

          {showMystery &&
            <Link to="/bundle/mystery" className="secondary-nav-link" onClick={() => onLinkClick('/bundle/mystery', 'Mystery')}>
              <FormattedMessage id="nav-secondary.link.mystery" defaultMessage="Mystery" />
            </Link>
          }

          <StarDealButton className="secondary-nav-link" />

          {showGiftGuide &&
            <Link to="/gift-guide" className="secondary-nav-link" onClick={() => onLinkClick('/gift-guide', 'GiftGuide')}>
              <FormattedMessage id="nav-secondary.link.gift-guide" defaultMessage="Gift Guide" />
            </Link>
          }
        </div>

        <div className="right-links-container">
          {showRedeemCode &&
            <Link to="/redeem-code" className="secondary-nav-link" onClick={() => onLinkClick('/redeem-code', 'RedeemCode')}>
              <FormattedMessage id="nav-secondary.link.redeem-code" defaultMessage="Redeem" />
            </Link>
          }
          {showSupport &&
            <a href={`${supportUrl()}`} target="_blank" rel="noopener noreferrer" className="secondary-nav-link" onClick={() => onLinkClick(`${supportUrl()}`, 'Support')}>
              <FormattedMessage id="nav-secondary.link.support" defaultMessage="Support" />
            </a>
          }
          {showBlogLink &&
            <Link to="/blog" className="secondary-nav-link" onClick={() => onLinkClick('/blog', 'Blog')}>
              <FormattedMessage id="nav-secondary.link.blog" defaultMessage="Blog" />
            </Link>
          }
        </div>

      </Container>
    </div>
  );
};

SecondaryNavBar.propTypes = {
  setMegaMenuTab: PropTypes.func,
  megaMenuTab: PropTypes.string,
  siteBrand: PropTypes.string,
  onMegaMenuIntent: PropTypes.func,
};

SecondaryNavBar.defaultProps = {
  setMegaMenuTab: () => {},
  megaMenuTab: '',
  siteBrand: 'fanatical',
  onMegaMenuIntent: () => {},
};

export default SecondaryNavBar;
